import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { Observable } from 'rxjs/Observable';

import { Group } from '../models/group.model';
import { SetKioskLocale } from '../../kiosk/kiosk.actions';
import { SetLocale } from '../../main/locale/locale.actions';

@Component({
  selector: 'app-header',
  template: require('./app-header.component.html'),
  styles: [require('./app-header.component.scss')],
  preserveWhitespaces: false,
})
export class AppHeaderComponent implements OnInit {
  @HostBinding('attr.role') role = 'banner';

  group$: Observable<Group>;

  constructor(
    @Inject('$translate') private $translate,
    @Inject('LanguageService') public languageService,
    private store: Store<AppState>,
  ){}

  ngOnInit(): void {
    this.group$ = this.store.select((state: AppState): Group => state.group);
  }

  switchLanguage() {
    this.languageService.switchLanguage();
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/app-header/app-header.component.ts